import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveCheck } from 'core/providers/Responsive';

import {
	Wrapper,
	OverFlower,
} from './thumbStyles';

import ThumbSorter from './thumbSorter';

const getEagerLoadNum = (isMobile) => isMobile ? 2 : 3;

const isLazy = (id, isMobile, force) => {
	if (force) return true;
	return id >= getEagerLoadNum(isMobile);
};

const Thumbs = ({ media, slideTrigger, activeSlide, ratio, openOnClick, listingName, lazy }) => {
	const handleClick = idx => {
		// if there's no lightbox or user clicked non-active slide, move to that slide
		if (typeof openOnClick === 'undefined' || activeSlide !== idx) {
			slideTrigger(idx);
			// if we have a lightbox and the user is clicking the highlighted slide, let's open that lightbox
		} else {
			openOnClick(idx)();
		}
	};
	return (
		<ResponsiveCheck>{({ isMobile }) => (
			<Wrapper>
				<OverFlower>
					{media && media.map((m, id) =>
						<ThumbSorter
							key={id}
							{...m}
							trigger={() => handleClick(id)}
							isCurrent={activeSlide === id}
							ratio={ratio}
							maxIndex={media.length}
							isLazy={isLazy(id, isMobile, lazy)}
							listingName={listingName}
							photoNum={id}
						/>
					)}
				</OverFlower>
			</Wrapper>
		)}</ResponsiveCheck>
	);
};

Thumbs.propTypes = {
	media: PropTypes.arrayOf(PropTypes.shape({
		url: PropTypes.string.isRequired,
		thumbnail: PropTypes.string,
		name: PropTypes.string,
	})).isRequired,
	activeSlide: PropTypes.number.isRequired,
	slideTrigger: PropTypes.func,
	ratio: PropTypes.string,
	openOnClick: PropTypes.func,
	listingName: PropTypes.string,
	lazy: PropTypes.bool,
};


export default Thumbs;
